<template>
  <v-card>
    <v-card-title>
      <div class="headline">{{data.quoteInfo.product}}</div>
    </v-card-title>
    <v-card-text>
      <v-layout wrap>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.proposalNo}}</v-subheader>
          <div class="title">{{data.quoteInfo.proposalNo}}</div>
        </v-flex>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.paid}}</v-subheader>
          <div class="title">{{checkPaid(data.quoteInfo.paid)}}</div>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.selectedPlan}}</v-subheader>
          <div class="title">{{data.quoteInfo.plan}}</div>
        </v-flex>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.duration}}</v-subheader>
          <div class="title">{{data.quoteInfo.duration}}</div>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.comDate}}</v-subheader>
          <div class="title">{{formatDisplayDate(data.quoteInfo.startDate)}}</div>
        </v-flex>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.expDate}}</v-subheader>
          <div class="title">{{formatDisplayDate(data.quoteInfo.endDate)}}</div>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.premiumPaid}}</v-subheader>
          <div class="title">{{formatDisplayNumber(data.quoteInfo.premium)}}</div>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import { globalMixin } from './globalMixin'

export default {
  data() {
    return {
      labels: {
        proposalNo: 'Proposal No.',
        paid: 'Paid Status',
        selectedPlan: 'Selected Plan',
        duration: 'Duration',
        comDate: 'Commencement Date',
        expDate: 'Expired Date',
        premiumPaid: 'Premium Paid'
      }
    }
  },
  methods: {
    checkPaid(value) {
      if (value) {
        return 'Paid'
      } else {
        return 'Unpaid'
      }
    }
  },
  computed: {
    data() {
      return this.$store.state.adminMember.member.trans
    }
  },
  mixins: [globalMixin]
}
</script>

<style>
</style>
